import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import {
    getBasisType,
    createChargeBasis,
    getChargeBasisbyId,
    updateChargeBasis
} from "../../../ReduxStore/Slice/Pricing/ChargeBasisSlice";
import sweatalert from "sweetalert2";
import {
    EMPTY_CHARGE_BASIS_NAME_ERROR,
    EMPTY_MIN_BAND_BASIS_ERROR,
    EMPTY_FREQUENCY_NAME_ERROR,
    EMPTY_PRICING_QUERY

} from "../../../Utils/Common_Error";
import Swal from 'sweetalert2';


const CreateChargebasis = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const agent_id = JSON.parse(localStorage.getItem("agent_id"));
    const agent_db = localStorage.getItem("agent_db");

    // console.log("location", location.state.data.deleted)
    const token = localStorage.getItem("token");
    const [getBasisTypeData, setGetBasisTypeData] = useState([]);

    const [status, setStatus] = useState("1");
    const [increment, setIncrementType] = useState("0");

    const [selfAssessment, setSelfAssessment] = useState("0");



    const [formData, setFormData] = useState({
        name: "",
        basistypes_id: getBasisTypeData?.[0]?.id || "",
    });

    const [errors, setErrors] = useState({});

    const [chargeBasisName, setChargeBasisName] = useState("")

    const [selectedType, setSelectedType] = useState("")

    const [bands, setBands] = useState([{ min: "", max: "" }]);
    const [frequencyBands, setFrequencyBands] = useState([{ value1: "" }]);


    const [pricingQury, setPricingQuer] = useState("")

    const [pquryType, setPquryType] = useState("")

    const [chargeBasisEditData, setChargeBasisEditData] = useState([]);


    const [selectedBasisTypeId, setSelectedBasisTypeId] = useState("");


    useEffect(() => {
        GetBasisType();
        getEditData();
    }, []);

    useEffect(() => {
        if (chargeBasisEditData[0]?.status) {
            setStatus(chargeBasisEditData[0]?.status);
        }
    }, [chargeBasisEditData]);


    const GetBasisType = async () => {
        const req = { token: token, agent_id: agent_id };
        try {
            const res = await dispatch(getBasisType(req)).unwrap();
            if (res.status) {
                if (['prelivecrm_latest', 'staging_group', 'livednsgroup'].includes(agent_db)) {
                    setGetBasisTypeData(res.data);
                } else {
                    setGetBasisTypeData(res.data.filter((item) => item.id !== 5));
                }

            } else {
                setGetBasisTypeData([]);
            }
        } catch (err) {
            console.log("Error in getting Basis Type", err);
        }
    };

    const getEditData = async () => {
        const req = { token: token, id: location.state.data.id, agent_id: agent_id };
        try {
            const res = await dispatch(getChargeBasisbyId(req)).unwrap();


            if (res.status) {
                setChargeBasisEditData(res.data);
                setSelectedBasisTypeId(res.data[0].basistypes_id)

                setChargeBasisName(res.data[0]?.name)
                setPricingQuer(res.data[0]?.pricing_queries)
                setIncrementType(res.data[0].incremental_price)
                setSelfAssessment(res.data[0].self_assessment)


                if (res.data[0]?.ChargeTypes) {
                    if (res.data[0]?.basistypes_id == 3) {

                        let CharbasesData = res.data[0]?.ChargeTypes?.map((data) => {

                            return { ...data, min: data.name.split("-")[0], max: data.name.split("-")[1] }
                        })
                        setBands(CharbasesData)
                    } else if (res.data[0]?.basistypes_id == 4) {
                        let CharbasesData = res.data[0]?.ChargeTypes?.map((data) => {

                            return { ...data, value1: data.name.split("-")[0] }
                        })
                        setFrequencyBands(CharbasesData)
                    }
                }


            } else {
                setChargeBasisEditData([]);
            }
        } catch (err) {
            console.log("Error in getting charge basis data", err);
        }
    };


    // useEffect(() => {
    //     if (chargeBasisEditData[0]?.basistypes_id) {
    //         setSelectedBasisTypeId(chargeBasisEditData[0]?.basistypes_id);
    //     }
    // }, [chargeBasisEditData]);

    useEffect(() => {
        if (!(selectedBasisTypeId == 5 || selectedBasisTypeId == 1)) {
            setSelfAssessment("0");
            setIncrementType("0");
        } else {
            setIncrementType(chargeBasisEditData[0].incremental_price)
            setSelfAssessment(chargeBasisEditData[0].self_assessment)
        }
    }, [selectedBasisTypeId])

    const handleSelectChange = (e) => {
        const selectedId = parseInt(e.target.value);
        setSelectedBasisTypeId(selectedId);
    };

    useEffect(() => {
        if (selectedBasisTypeId === 1) {
            setPquryType("input");
        } else if (selectedBasisTypeId === 5) {
            setPquryType("radio");
        } else {
            setPquryType("");
        }
    }, [selectedBasisTypeId]);


    const handleAdd = () => {
        setBands([...bands, { min: "", max: "" }]);
    };

    const handleRemove = (index ,band) => {
        // if(band?.PackageEnterDefaultValues?.length > 0){
        //    Swal.fire({
        //            icon: "warning",
        //            title: "Warning",
        //            text: "This value is used in a package. Remove it from the package first.",
        //            timer: 7000,
        //            timerProgressBar: true,
        //          });
        //     return;
        // }

        const updated = bands.filter((_, i) => i !== index);
        setBands(updated);
    };



    const handleChange = (index, field, value) => {
        const updated = [...bands];
        updated[index][field] = value;
        setBands(updated);
    };



    const handleAdd1 = () => {
        setFrequencyBands([...frequencyBands, { value1: "" }]);
    };

    const handleRemove1 = (indexToRemove, band) => {

        // if(band?.PackageEnterDefaultValues?.length > 0){
        //    Swal.fire({
        //            icon: "warning",
        //            title: "Warning",
        //            text: "This value is used in a package. Remove it from the package first.",
        //            timer: 7000,
        //            timerProgressBar: true,
        //          });
        //     return;
        // }


        const updatedBands = frequencyBands.filter((_, idx) => idx !== indexToRemove);
        setFrequencyBands(updatedBands);
    };

    const handleChange1 = (index, key, val) => {
        const updatedBands = [...frequencyBands];
        updatedBands[index][key] = val;
        setFrequencyBands(updatedBands);
    };



    const handleSubmit = async (e) => {
        e.preventDefault();

        const newErrors = {};

        if (!chargeBasisName?.trim()) {
            newErrors.name = EMPTY_CHARGE_BASIS_NAME_ERROR;
        } else if (selectedBasisTypeId !== 2 && !pricingQury?.trim()) {
            setPricingQuer("");
            newErrors.pricingQury = EMPTY_PRICING_QUERY;
        }
        else {
            if (selectedBasisTypeId === 3) {
                bands.forEach((band, index) => {
                    if (!band.min?.trim()) {
                        newErrors[`band-${index}`] = EMPTY_MIN_BAND_BASIS_ERROR;
                    }
                });
            }

            if (selectedBasisTypeId === 4) {
                frequencyBands.forEach((band, index) => {
                    if (!band.value1?.trim()) {
                        newErrors[`freqBand-${index}`] = EMPTY_FREQUENCY_NAME_ERROR;
                    }
                });

            }
        }

        console.log("Validation errors", newErrors);

        setErrors(newErrors);

        if (Object.keys(newErrors).length === 0) {
            let req = {
                id: chargeBasisEditData[0].id,
                name: chargeBasisName,
                basistypes_id: selectedBasisTypeId,
                agent_id: agent_id,
                status: status,
                incremental_price: increment,
                pricing_queries: pricingQury,
                pricing_queries_type: pquryType,
                self_assessment: selfAssessment,

                chargetype:
                    selectedBasisTypeId === 3
                        // ? bands.map(b => (b.max?.trim() ? `${b.min}-${b.max}` : `${b.min}`))
                        // ? bands.map(b => ({ id: b.id, name: b.min +"-"+b.max }))
                        ? bands.map(b => ({
                            id: b.id,
                            name: b.max?.trim() ? `${b.min}-${b.max}` : `${b.min}`
                        }))
                        : selectedBasisTypeId === 4
                            ? frequencyBands.map(b => ({ id: b.id, name: b.value1 }))
                            : []
            };

            // return


           

            await dispatch(updateChargeBasis(req)).unwrap()
                .then((res) => {
                    if (res.status) {
                        sweatalert.fire({
                            title: "Success",
                            text: res.msg,
                            icon: "success",
                            timer: 3000,
                        });
                        navigate("/admin/pricing/all-charge-basis");
                    } else {
                        sweatalert.fire({
                            title: "Error",
                            text: res.msg,
                            icon: "error",
                            timer: 3000,
                        });
                    }
                })
                .catch((err) => {
                    console.log("Error in creating charge basis", err);
                });
        }
    };


    return (
        <>
            <div className="row mb-4">
                <div className="col">
                    <h4 className="page-title">
                        <Link to="/admin/pricing/all-charge-basis">
                            <i className="bx bx-arrow-back text-pink"></i>
                        </Link>{" "}
                        Charge Basis
                    </h4>
                </div>
            </div>
            <div className="card form-card">
                <div className="card-header d-flex justify-content-between align-items-center">
                    <h5 className="card-title mb-0">Edit Charge Basis</h5>


                    <div className="">
                        <div className="d-flex justify-content-sm-center  justify-content-lg-start align-items-center">
                            <label htmlFor="status" className=" col-form-label py-0">
                                Status:
                            </label>

                            <div className="form-switch ms-2">
                                {/* <input
                                    disabled={location.state.data.deleted == false ? true : false}
                                    className="form-check-input"
                                    type="checkbox"
                                    // id="statusSwitch"
                                    id={`statusSwitch-${chargeBasisEditData[0]?.id}`}
                                    checked={chargeBasisEditData[0]?.status === "1"}
                                    onChange={() => setStatus(prev => (prev === "1" ? "0" : "1"))}
                                /> */}

                                <input
                                    disabled={location.state.data.deleted == false}
                                    className="form-check-input ms-0 mt-0"
                                    type="checkbox"
                                    id={`statusToggle-${chargeBasisEditData[0]?.id}`}
                                    checked={status === "1"}
                                    onChange={() => setStatus(prev => (prev === "1" ? "0" : "1"))}
                                />


                            </div>
                        </div>


                    </div>

                </div>



                <div className="card-body px-0 px-lg-3">
                    <form>
                        <div className="">
                            <div className="row px-2">
                                <div className="col-md-6 mb-3">
                                    <div className="row justify-content-sm-center  justify-content-lg-start">
                                        <label className="col-form-label col-sm-3" htmlFor="name">
                                            Name of charge basis:
                                        </label>
                                        <div className=" col-sm-9">
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="name"
                                                name="name"
                                                placeholder="Enter Name of charge basis"
                                                value={chargeBasisName}
                                                onChange={(e) => setChargeBasisName(e.target.value)}

                                            />
                                            {errors.name && chargeBasisName?.trim() === '' && (
                                                <div style={{ color: '#ff00a2', fontSize: '0.875rem', marginTop: '0.25rem' }}>
                                                    {errors.name}
                                                </div>
                                            )}


                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 mb-3">
                                    <div className="row justify-content-sm-center justify-content-lg-start">
                                        <label className="col-form-label col-sm-3" htmlFor="basistypes_id">
                                            Type:
                                        </label>
                                        <div className="col-sm-9">
                                            <select
                                                disabled={location.state.data.deleted == false}
                                                className="default-select wide form-select"
                                                id="basistypes_id"
                                                name="basistypes_id"
                                                value={selectedBasisTypeId}
                                                onChange={handleSelectChange}
                                            >
                                                {getBasisTypeData?.map((data) => (
                                                    <option key={data.id} value={String(data.id)}>
                                                        {data.name}
                                                    </option>
                                                ))}
                                            </select>

                                        </div>
                                    </div>
                                </div>

                                {selectedBasisTypeId !== 2 && (
                                    <>

                                        <div className="col-md-6 mb-3">
                                            <div className="row justify-content-sm-center  justify-content-lg-start">
                                                <label className="col-form-label col-sm-3" htmlFor="name">
                                                    Pricing Queries:
                                                </label>
                                                <div className=" col-sm-9">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        id="pqury"
                                                        name="pqury"
                                                        placeholder="Enter Pricing Queries"
                                                        value={pricingQury}
                                                        onChange={(e) => setPricingQuer(e.target.value)}
                                                    />
                                                    {errors.pricingQury && pricingQury?.trim() === '' && (
                                                        <div style={{ color: '#ff00a2', fontSize: '0.875rem', marginTop: '0.25rem' }}>
                                                            {errors.pricingQury}
                                                        </div>
                                                    )}


                                                </div>
                                            </div>
                                        </div>


                                        {selectedBasisTypeId !== 3 && selectedBasisTypeId !== 4 && (
                                            <div className="col-md-6 mb-3">
                                                <div className="row justify-content-sm-center justify-content-lg-start">
                                                    <label className="col-form-label col-sm-3" htmlFor="basistypes_id">
                                                        Type:
                                                    </label>
                                                    <div className="col-sm-9">
                                                        <select
                                                            className="default-select wide form-select"
                                                            id="basistypes_id"
                                                            name="basistypes_id"
                                                            value={pquryType}
                                                            // onChange={handlePquryType}
                                                            disabled
                                                        >

                                                            <option value="">Select Type</option>
                                                            <option value="radio">Radio</option>
                                                            <option value="input">Input</option>

                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                    </>


                                )}


                                {(selectedBasisTypeId === 1 || selectedBasisTypeId === 5) && (
                                    <>
                                        {selectedBasisTypeId === 5 && (
                                            <div className="col-md-4 mb-3">
                                                <div className="row justify-content-sm-center  justify-content-lg-start">
                                                    <label htmlFor="status" className="col-sm-4 col-form-label">
                                                        Incremental Price:
                                                    </label>
                                                    <div className="col-sm-7">
                                                        <div className="form-switch">
                                                            <input
                                                                className="form-check-input"
                                                                type="checkbox"
                                                                id="status"
                                                                checked={increment === "1"}
                                                                onChange={() => setIncrementType(prev => (prev === "1" ? "0" : "1"))}

                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        <div className="col-md-4 mb-3">
                                            <div className="row justify-content-sm-center  justify-content-lg-start">
                                                <label htmlFor="status1" className="col-sm-4 col-form-label">
                                                    Self Assessment Applicability:
                                                </label>
                                                <div className="col-sm-7">
                                                    <div className="form-switch">
                                                        <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            id="status1"
                                                            checked={selfAssessment === "1"}
                                                            onChange={() => setSelfAssessment(prev => (prev === "1" ? "0" : "1"))}

                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </>
                                )}

                            </div>


                              
                            {selectedBasisTypeId === 3 && (
                                <div className="gray-card">
    
                                    {bands.map((band, index) => (

                                        
                                        <div className="row align-items-center mb-2 w-100 mx-auto" key={index}>
                                            <div className="col d-flex justify-content-between ">
                                                <label className="mb-0  col-form-label col-2" >
                                                    Set default band:
                                                </label>

                                                <div className="w-100 ms-5 me-2">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Min Value"
                                                        value={band.min}
                                                        onChange={(e) => handleChange(index, "min", e.target.value)}
                                                    />
                                                    {!band.min && errors[`band-${index}`] && (
                                                        <div style={{ color: '#ff00a2', fontSize: '0.875rem', marginTop: '0.25rem' }}>
                                                            {errors[`band-${index}`]}
                                                        </div>
                                                    )}
                                                </div>

                                                <div className="w-100">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Max Value"
                                                        value={band.max}
                                                        onChange={(e) => handleChange(index, "max", e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col d-flex justify-content-end">
                                                <span
                                                    className={`fs-2 ${index === bands.length - 1
                                                        ? "text-pink"
                                                        : "text-danger"
                                                        }`}
                                                >
                                                    {index === bands.length - 1 ? (
                                                        <>
                                                            {bands.length != 1 && (
                                                                

                                                                <i className="fa-regular fa-circle-minus fs-2 text-pink plusMinus-circle"
                                                                    onClick={() =>
                                                                        handleRemove(index,band)
                                                                    }
                                                                ></i>
                                                                

                                                            )}
                                                            
                                                            <i className="fa-regular d-block fa-circle-plus mt-3 fs-2 text-pink plusMinus-circle"
                                                            onClick={() =>
                                                                handleAdd(index)
                                                            }></i>
                                                        </>
                                                    ) : (
                                                       
                                                        <i className="fa-regular fa-circle-minus fs-2 text-pink plusMinus-circle" onClick={() =>
                                                            handleRemove(index,band)
                                                        }></i>
                                                      
                                                    )}
                                                </span>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}


                            
                            {selectedBasisTypeId === 4 && (
                                <div className="gray-card" style={{ backgroundColor: "#fafafa" }}>

                                    {frequencyBands.map((band, index) => (
                                        <div className="row mb-2 mx-auto" key={index}>
                                            <div className="col d-flex justify-content-between">
                                                <label className=" col-form-label" >
                                                    Frequency Type:
                                                </label>

                                                <div className="col ms-3">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter Frequency Name"
                                                        value={band.value1}
                                                        onChange={(e) => handleChange1(index, "value1", e.target.value)}
                                                    />
                                                    {!band.value1 && errors[`freqBand-${index}`] && (
                                                        <div style={{ color: '#ff00a2', fontSize: '0.875rem', marginTop: '0.25rem' }}>
                                                            {errors[`freqBand-${index}`]}
                                                        </div>
                                                    )}
                                                </div>

                                            </div>
                                            <div className="col text-end col text-end d-flex align-items-center justify-content-end">
                                                <span
                                                    className={`fs-2 ${index === frequencyBands.length - 1
                                                        ? "text-pink"
                                                        : "text-danger"
                                                        }`}
                                                >
                                                    {index === frequencyBands.length - 1 ? (
                                                        <>
                                                            {frequencyBands.length != 1 && (

                                                                
                                                                <i className="fa-regular d-block fa-circle-minus fs-2 text-pink plusMinus-circle"
                                                                    onClick={() =>
                                                                        handleRemove1(index ,band)
                                                                    }
                                                                ></i>
                                                                
                                                            )}

                                                            <i className="fa-regular d-block fa-circle-plus mt-3 fs-2 text-pink plusMinus-circle"
                                                                onClick={() =>
                                                                    handleAdd1(index)}
                                                            ></i>
                                                        </>
                                                    ) : (
                                                        
                                                        <i className="fa-regular d-block fa-circle-minus fs-2 text-pink plusMinus-circle"
                                                            onClick={() =>
                                                                handleRemove1(index ,band)
                                                            }
                                                        ></i>
                                                        
                                                    )}
                                                </span>
                                            </div>
                                        </div>
                                    ))}

                                </div>
                            )}



                            <div className="text-end mt-4 mb-0">
                                <button type="button" className="btn btn-outline-secondary rounded " onClick={() => window.history.back()}>
                                    <i className="fa fa-xmark" /> Cancel
                                </button>
                                <button
                                    className="btn btn-pink rounded ms-2"
                                    type="button"
                                    onClick={handleSubmit}
                                >
                                    <i className="far fa-save" /> Update
                                </button>

                            </div>
                        </div>
                    </form>
                </div >


            </div >
        </>
    );
};

export default CreateChargebasis;
